<txp-header>
    <div class="main-actions">
        <h1 class="brand-title" [matMenuTriggerFor]="brandMenu" #brandMenuButton="matMenuTrigger" [ngClass]="{ 'disabled': !brandId || !showBrandList || isCallCenterTimerStarted }" (menuOpened)="onBrandMenuOpened()">
            {{ brandName }}

            <span class="arrow" [hidden]="!brandId || !showBrandList || isCallCenterTimerStarted">
                <i class="tce-icon-dropdown-open" *ngIf="brandMenuButton.menuOpen"></i>
                <i class="tce-icon-dropdown-closed" *ngIf="!brandMenuButton.menuOpen"></i>
            </span>
        </h1>

        <div class="call-timer-container" *ngIf="isCallCenterTimerStarted">
            <span>{{ 'callCenter.callTime' | translate }}: {{ currentCallTime }}</span>
            <txp-button [style]="buttonStyle.PRIMARY"
                        data-qa-label="CallCenterTimer"
                        matTooltip="{{ 'callCenter.endCall' | translate}}"
                        [attr.title]="'callCenter.endCall' | translate"
                        (click)="endCall()"
                        [disabled]="(orderStep$ | async) === orderStep.Disposition && isCallCenterModeActive">
                {{ 'callCenter.endCall' | translate }}
            </txp-button>
        </div>
    </div>

    <div [formGroup]="form" class="app-switcher-container">
        <mat-select class="language-selector"
                    (selectionChange)="onChangeLanguage($event)"
                    formControlName="language"
                    data-qa-label="languageInput"
                    *ngIf="supportedLanguages?.length"
                    placeholder="{{ 'brand.businessInfo.language' | translate }}"
                    required>
            <mat-option *ngFor="let language of supportedLanguages"
                        [value]="language">
                {{ 'brand.businessInfo.' + language | translate }}
            </mat-option>
        </mat-select>

        <div class="logo-container" [matMenuTriggerFor]="appMenu" #appsMenuButton="matMenuTrigger"
            [ngClass]="{ 'disabled': !isAppMenuAvailable }">
            <img class="tillster-logo"
                 [ngClass]="{ 'reseller-logo': resellerLogoUrl }"
                 [src]="resellerLogoUrl || 'assets/images/tillster-logo.svg'"
                 [alt]="resellerLogoUrl ? 'Reseller Logo' : 'Tillster Logo'" />
            <div>
                <span class="arrow"
                    [hidden]="!isAppMenuAvailable">
                    <i class="tce-icon-dropdown-open" *ngIf="appsMenuButton.menuOpen"></i>
                    <i class="tce-icon-dropdown-closed" *ngIf="!appsMenuButton.menuOpen"></i>
                </span>
            </div>
            <mat-menu #appMenu="matMenu" class="app-grid-menu">
                <div class="app-grid-container">
                    <button mat-menu-item class="app-grid-item" (click)="setAppMode(true)"
                        *ngIf="brandId && callCenterEnabled && isCallCenterModeAvailable && !isCallCenterModeActive">
                        <div class="app-icon">
                            <i class="tce-icon-phone"></i>
                        </div>
                        <span>{{ 'app.nav.callCenter' | translate}}</span>
                    </button>
                    <button mat-menu-item class="app-grid-item" (click)="setAppMode(false)"
                        *ngIf="isCallCenterModeActive">
                        <div class="app-icon">
                            <i class="tce-icon-brand"></i>
                        </div>
                        <span>{{ 'header.backToTceAdmin' | translate}}</span>
                    </button>
                    <button mat-menu-item class="app-grid-item" (click)="openXpApp()"
                        *ngIf="isXpAppAvailable">
                        <div class="app-icon">
                            <i class="tce-icon-xp"></i>
                        </div>
                        <span>{{ 'app.nav.txp' | translate}}</span>
                    </button>
                    <button mat-menu-item class="app-grid-item" (click)="setResellerMode(true)"
                        *ngIf="isResellerAvailable && !isResellerModeActive">
                        <div class="app-icon">
                            <i class="tce-icon-salesman"></i>
                        </div>
                        <span>{{ 'app.nav.reseller' | translate}}</span>
                    </button>
                    <button mat-menu-item class="app-grid-item" (click)="setResellerMode(false)"
                        *ngIf="isResellerModeActive">
                        <div class="app-icon">
                            <i class="tce-icon-brand"></i>
                        </div>
                        <span>{{ 'header.backToTceAdmin' | translate}}</span>
                    </button>
                </div>
            </mat-menu>
        </div>
    </div>
</txp-header>

<mat-menu #brandMenu="matMenu" class="brand-menu">
    <txp-brand-detail
        (closeParent)="trigger.closeMenu()"
        (click)="$event.stopPropagation()"
        (keydown.shift.tab)="$event.stopPropagation();"(keydown.tab)="$event.stopPropagation();">
    </txp-brand-detail>
</mat-menu>
